import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LibApiBaseService, LibHttpErrorHandler } from 'ngx-mat-base-comp';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class EntityService extends LibApiBaseService<any> {

    static appSettings: any;
    
    constructor(
      http: HttpClient,
      httpErrorHandler: LibHttpErrorHandler,
      ) {
      super(
        http,
        httpErrorHandler,
        environment.baseURLHubAPI,
        'entity'
      );
    }
}
